import { Drawer, Row, Col, Card, Tooltip, Button, notification } from "antd";
import React from "react";
import { connect } from "react-redux";
import { TableComp } from "sz-react-utils";
import Request from "../../../../request";
import moment from "moment";

const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : "DD.MM.YYYY"

class EnrollmentDrawer extends React.Component {
    state = {
        visible: true,
        count: 0
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 200)
    }

    apiRequest = () => {
        return new Promise(async (resolve) => {
            let response = await Request.getTodaysEnrollment()
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    sendEnrollmentMail = async(studentId) =>{
        let response = await Request.sendStudentEnrollmentMail(studentId);
       if(response.success) {
        notification.success({
            message:response.message
        })
       }else {
        notification.error({
            message:response.message
        })
       }
       this.table.current.reload()
    }


    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    render() {
        let { visible } = this.state
        let columns = [
            {
                title: 'Sr No.',
                key: 'serialNumeber',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <Tooltip title="Send Enrollment Email">
                        <Button
                            size="small"
                            loading={false}
                            onClick={() => { this.sendEnrollmentMail({_id:record._id}) }}
                            shape="circle"
                            icon="forward"
                        />
                    </Tooltip>
                )
            },
            {
                title: 'V.I.D',
                key: 'id'
            },
            {
                title: 'Student Name',
                key: 'studentName'
            },
            {
                title: 'University',
                key: 'visaDesk.selectedCourse.universityInstitutionName'
            },
            {
                title: 'Course',
                key: 'visaDesk.selectedCourse.courseName'
            },
            {
                title: 'Country',
                key: 'visaDesk.selectedCourse.countryName'
            },
            {
                title: 'Course Start Date',
                key: 'visaDesk.courseStartDate',
                render: (text, record) => (
                    moment(record.visaDesk.courseStartDate).format(dateFormat)
                )
            }
        ]
        return (
            <Drawer title={
                <div>
                    <React.Fragment>
                        Enrollment is Due Today : {this.state.count}
                    </React.Fragment>
                </div>
            }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible} >
                <Card bordered={false}>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        useFixedHeader={true}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 1200 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}


const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EnrollmentDrawer)
